document.addEventListener('DOMContentLoaded', function () {
  var lastTrigger = null;

  function openLightbox(trigger, lightbox) {
    lastTrigger = trigger;
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeLightbox(lightbox) {
    lightbox.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function onKeydown(event) {
    if (event.key !== 'Escape') return;
    var openLightboxEl = document.querySelector('.lightbox:not([hidden])');
    if (openLightboxEl) closeLightbox(openLightboxEl);
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-lightbox-open]');
    if (opener) {
      var targetId = opener.getAttribute('data-lightbox-open');
      var lightbox = document.getElementById(targetId);
      if (lightbox) openLightbox(opener, lightbox);
      return;
    }

    var closer = event.target.closest('[data-lightbox-close]');
    if (closer) {
      var lightboxEl = closer.closest('.lightbox');
      if (lightboxEl) closeLightbox(lightboxEl);
      return;
    }

    if (event.target.classList.contains('lightbox') && !event.target.hidden) {
      closeLightbox(event.target);
    }
  });
});
